export const isUserInProject = (project, userID) =>
  project.users.items.findIndex((user) => user.userID === userID) > -1;
